
/*
 * PAWS & PEARLS — SECRET SKY
 * MAGICAL ROSE-GOLD NIGHT BIRD CRY V1
 *
 * Independent audio companion to the existing
 * luminous night-bird animation.
 *
 * Does not alter the Chocolate Waltz,
 * wind, daytime birds, House sound controls,
 * animation frames or balloon journey.
 */

(function () {
  'use strict';

  var stage = document.getElementById(
    'pp-muse-balloon-stage'
  );

  var button = stage &&
    stage.querySelector('button.pp-balloon');

  if (
    !button ||
    stage.dataset.ppNightBirdCryV1 === '1'
  ) return;

  stage.dataset.ppNightBirdCryV1 = '1';

  var AUDIO_URL =
    'https://cdn.shopify.com/s/files/1/0784/0831/9166/files/Paws_Pearls_Secret_Sky_Magical_Rose_Gold_Bird_v1.mp3?v=1793172418';

  // Initial audition volume.
  var PEAK_VOLUME = 0.30;

  var QUIET_VOLUME = 0.001;
  var CLIP_SECONDS = 7.54;

  var FADE_IN_SECONDS = 0.55;
  var FADE_OUT_SECONDS = 1.30;

  var MAX_WAIT_SECONDS = 105;

  var player = null;
  var timer = 0;
  var launchedAt = 0;
  var cryAt = 0;

  var active = false;
  var cryStarted = false;
  var disposed = false;

  function houseAllowsSound() {
    var house = window.ppHouseSound;

    if (
      !house ||
      typeof house.isEnabled !== 'function'
    ) return false;

    try {
      return house.isEnabled() === true;
    } catch (_error) {
      return false;
    }
  }

  function birdStatus() {
    var bird = window.ppMuseLuminousNightBirdV1;

    if (
      !bird ||
      typeof bird.getStatus !== 'function'
    ) return null;

    try {
      return bird.getStatus();
    } catch (_error) {
      return null;
    }
  }

  function stop() {
    active = false;
    cryStarted = false;

    if (timer) {
      clearInterval(timer);
      timer = 0;
    }

    if (player) {
      try {
        player.volume = QUIET_VOLUME;
        player.pause();
        player.currentTime = 0;
      } catch (_error) {}
    }
  }

  function tick() {
    if (!active || disposed) return;

    if (
      !houseAllowsSound() ||
      document.hidden
    ) {
      stop();
      return;
    }

    var now = performance.now();

    if (
      (now - launchedAt) / 1000 >=
      MAX_WAIT_SECONDS
    ) {
      stop();
      return;
    }

    var state = birdStatus();

    if (!cryStarted) {

      // Wait for the actual bird animation.
      // No guessed soundtrack timestamp.

      if (
        !state ||
        state.phase !== 'crossing' ||
        !state.flying
      ) return;

      cryStarted = true;
      cryAt = now;

      try {
        player.currentTime = 0;
        player.volume = QUIET_VOLUME;
      } catch (_error) {
        stop();
      }

      return;
    }

    var elapsed = (now - cryAt) / 1000;

    if (
      elapsed >= CLIP_SECONDS ||
      !state ||
      !state.flying
    ) {
      stop();
      return;
    }

    // Gentle introduction and fade-out.

    var fadeIn = Math.min(
      1,
      elapsed / FADE_IN_SECONDS
    );

    var fadeOut = Math.min(
      1,
      (CLIP_SECONDS - elapsed) /
        FADE_OUT_SECONDS
    );

    if (player) {
      player.volume =
        QUIET_VOLUME +
        (PEAK_VOLUME - QUIET_VOLUME) *
        Math.max(
          0,
          Math.min(fadeIn, fadeOut)
        );
    }
  }

  function onClick() {
    if (
      disposed ||
      active ||
      !houseAllowsSound()
    ) return;

    if (
      window.matchMedia &&
      window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches
    ) return;

    var state = birdStatus();

    // Requires the existing visual bird.
    // Do nothing if it is not installed.

    if (!state || !state.installed) return;

    if (!player) {
      player = new Audio(AUDIO_URL);
      player.preload = 'auto';
      player.loop = true;
    }

    try {
      player.pause();
      player.currentTime = 0;
      player.volume = QUIET_VOLUME;

      launchedAt = performance.now();

      active = true;
      cryStarted = false;

      // Authorise playback during the
      // genuine balloon click for Safari.
      //
      // Effectively silent until the
      // animated bird actually appears.

      var result = player.play();

      if (
        result &&
        typeof result.catch === 'function'
      ) {
        result.catch(function (error) {
          if (active) {
            console.warn(
              '[P&P Night Bird Cry] Playback unavailable:',
              error
            );

            stop();
          }
        });
      }

      timer = setInterval(tick, 75);

    } catch (error) {
      console.warn(
        '[P&P Night Bird Cry] Unable to start:',
        error
      );

      stop();
    }
  }

  function onHouseChange() {
    if (!houseAllowsSound()) stop();
  }

  function onVisibility() {
    if (document.hidden) stop();
  }

  function onUnload(event) {
    var el = event && event.target;

    if (
      !el ||
      !(el === stage || el.contains(stage))
    ) return;

    disposed = true;
    stop();

    button.removeEventListener(
      'click', onClick
    );

    document.removeEventListener(
      'pp:house-sound-change',
      onHouseChange
    );

    window.removeEventListener(
      'pp:house-sound-change',
      onHouseChange
    );

    document.removeEventListener(
      'visibilitychange',
      onVisibility
    );

    document.removeEventListener(
      'shopify:section:unload',
      onUnload
    );

    window.removeEventListener(
      'pagehide', stop
    );
  }

  button.addEventListener('click', onClick);

  document.addEventListener(
    'pp:house-sound-change',
    onHouseChange
  );

  window.addEventListener(
    'pp:house-sound-change',
    onHouseChange
  );

  document.addEventListener(
    'visibilitychange',
    onVisibility
  );

  document.addEventListener(
    'shopify:section:unload',
    onUnload
  );

  window.addEventListener('pagehide', stop);

})();
